import React from 'react';

const InsightCreditPackageSuccess: React.FC = () => {
  return (
    <div className="auth multi-step-login">
      <div className="row h-100">
        <div className="col-lg-6 mx-auto">
          <div className="auth-form-light text-left p-5">
            <div className="brand-logo text-center">
              <a href="/">
                <img src="/images/logo.png" alt="logo" />
              </a>
            </div>

            <div className="text-center mb-4">
              <h2 className="text-success">Purchase Successful!</h2>
              <div className="check-circle mt-3 mb-4">
                <i className="mdi mdi-check-circle-outline text-success" style={{ fontSize: '48px' }}></i>
              </div>
              <p className="mb-3">
                Thank you for purchasing additional insight credits. Your credits have been added to your account.
              </p>
            </div>

            <div className="mt-4">
              <div className="d-flex flex-column align-items-center">
                <a
                  href="/dashboard"
                  className="btn btn-primary btn-lg mb-3"
                >
                  Go to Dashboard
                </a>
                <a
                  href="/chat"
                  className="btn btn-outline-primary btn-lg"
                >
                  Start Using AI Insights
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsightCreditPackageSuccess;
